<template>
  <iRow class="side-nav">
    <iMenu
      orientation="vertical"
      :active-item="activeItem"
      :items="parsedDigitalWalletNav"
      :menu-item-style-overrides="myStyleOverrides"
    />
  </iRow>
</template>

<script>
import { SIDE_NAV_DIGITAL_WALLET, SIDE_NAV_STYLE_OVERRIDES } from "@/constants/nav-constants";
import { parseUrlVars } from "@/helpers/parseUrlVars";
import { mapState } from "pinia";
import { useGeneralStore } from "%/stores/general-store";
import { filterMenuItems } from "@/helpers/capabilities-helper";

export default {
  name: "DigitalWalletSideNav",
  props: {
    activeItem: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState(useGeneralStore, [
      "orgId",
    ]),
    parsedDigitalWalletNav() {
      const filteredMenuItems = filterMenuItems(SIDE_NAV_DIGITAL_WALLET);
      return parseUrlVars(filteredMenuItems, { "{org_id}": this.orgId });
    },
    myStyleOverrides() {
      return SIDE_NAV_STYLE_OVERRIDES;
    },
  },
};
</script>
